import React from "react";
import { subSources } from "../constants/source-data";

interface SubSourceSelectorProps {
  sourceId: string;
  selectedSubSource: string;
  selectedSubSubSource: string;
  onSubSourceSelect: (subSourceId: string) => void;
  onSubSubSourceSelect: (subSubSourceId: string) => void;
  onSubSourceTextUpdate: (id: string, value: string) => void;
  subSourceTexts: Record<string, string>;
  textInputRef: React.RefObject<HTMLInputElement>;
}

export const SubSourceSelector: React.FC<SubSourceSelectorProps> = ({
  sourceId,
  selectedSubSource,
  selectedSubSubSource,
  onSubSourceSelect,
  onSubSubSourceSelect,
  onSubSourceTextUpdate,
  subSourceTexts,
  textInputRef,
}) => {
  const currentSubSources = subSources[sourceId];
  if (!currentSubSources) return null;

  return (
    <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
      <div className="text-blue-700 text-sm font-medium mb-3">
        💡 더 자세히 알려주세요
      </div>

      {/* 검색의 경우 "어디서" 질문 먼저 표시 */}
      {sourceId === "search" && (
        <div className="text-gray-700 text-sm font-medium mb-3">
          어디서 검색하셨나요?
        </div>
      )}

      <div className="space-y-3">
        {currentSubSources.map((subSource) => (
          <div key={subSource.id}>
            {subSource.type === "button" && (
              <div>
                <button
                  onClick={() => {
                    onSubSourceSelect(subSource.id);
                    if (subSource.id !== "other") {
                      onSubSourceTextUpdate(subSource.id, "");
                    }
                  }}
                  className={`w-full p-2 rounded-lg border transition-all duration-200 ${
                    selectedSubSource === subSource.id
                      ? "border-blue-500 bg-blue-500 text-white"
                      : "border-gray-300 text-gray-700 hover:border-blue-300"
                  }`}
                >
                  <span className="text-sm font-medium">{subSource.label}</span>
                </button>

                {/* 하위 하위 소스 (인플루언서 이름 등) */}
                {selectedSubSource === subSource.id &&
                  subSource.subSubSources && (
                    <div className="mt-2 ml-2 space-y-2">
                      {subSource.subSubSources.map((subSubSource) => (
                        <div key={subSubSource.id}>
                          {subSubSource.type === "button" ? (
                            <button
                              onClick={() =>
                                onSubSubSourceSelect(subSubSource.id)
                              }
                              className={`w-full p-2 rounded-lg border transition-all duration-200 ${
                                selectedSubSubSource === subSubSource.id
                                  ? "border-blue-500 bg-blue-500 text-white"
                                  : "border-gray-300 text-gray-700 hover:border-blue-300"
                              }`}
                            >
                              <span className="text-sm font-medium">
                                {subSubSource.label}
                              </span>
                            </button>
                          ) : (
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                {subSubSource.label}
                              </label>
                              <input
                                ref={
                                  subSubSource.id === "influencer_name"
                                    ? textInputRef
                                    : undefined
                                }
                                value={subSourceTexts[subSubSource.id] || ""}
                                onChange={(e) =>
                                  onSubSourceTextUpdate(
                                    subSubSource.id,
                                    e.target.value
                                  )
                                }
                                placeholder={subSubSource.placeholder}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition text-gray-700 bg-white text-sm"
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            )}

            {subSource.type === "text" && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {subSource.label}
                </label>
                <input
                  ref={
                    subSource.id === "how" ||
                    subSource.id === "cafe_name" ||
                    subSource.id === "store_review" ||
                    subSource.id === "school_name"
                      ? textInputRef
                      : undefined
                  }
                  value={subSourceTexts[subSource.id] || ""}
                  onChange={(e) =>
                    onSubSourceTextUpdate(subSource.id, e.target.value)
                  }
                  placeholder={subSource.placeholder}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition text-gray-700 bg-white text-sm"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
